export default function _filterRse() {
    const ctaButtons = document.querySelectorAll('.filters-ui_button');

    const drawerCloseButtons = document.querySelectorAll('.drawer-close');

    const overlay = document.getElementById('filter-modal');
    const pageBody = document.querySelector('body');
    function closeDrawer() {
        overlay.classList.remove('open');
        document.querySelector('.filters-ui .open').classList.remove('open');
        pageBody.style.overflow = 'auto';
    }

    drawerCloseButtons.forEach((el) => {
        el.addEventListener('click', closeDrawer);
    });

    ctaButtons.forEach((element) => {
        element.addEventListener('click', (e) => {
            e.stopPropagation();
            overlay.classList.add('open');

            const drawerType = e.target.dataset.drawertype;

            pageBody.style.overflow = 'hidden';

            document
                .querySelector(`.side-drawer--${drawerType}`)
                .classList.add('open');
        });
    });

    // close overlay on clicking background
    if (overlay) {
        overlay.addEventListener('click', () => {
            closeDrawer();
        });
    }
}

_filterRse();
